<template>
  <div :class="[
    'container',
    'ignore',
    { 'has-header': hasHeader },
    { 'has-footer': $slots.footer },
    { 'has-tabbar': isIndex },
  ]"
  >
    <header v-if="hasHeader" class="page-header" style="z-index: 12">
      <slot name="header" />
    </header>
    <main class="page-body">
      <slot />
    </main>
    <footer v-if="$slots.footer" class="page-footer">
      <slot name="footer" />
    </footer>
  </div>
</template>
<style lang="less" scoped>
.container {
  &.has-footer {
    padding-bottom: 110px;
  }
  &.has-header {
    padding-top: 88px;
  }
  .page-header {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
  }
  .page-body {
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
  }
  .page-footer {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
  }
}
</style>

<script>
export default {
  name: 'AppLayout',
  props: {
    isVideo: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      hasHeader: true,
    }
  },
  computed: {
    isIndex() {
      return this.$route.meta.isIndex;
    },
  },
};
</script>
